import WorkTimeReportComponent from "features/Report/components/workTimeGroup/WorkTimeReport";
import useWorkTimeReport from "features/Report/hooks/workTimeGroup/useWorkTimeReport";

const WorkTimeReportPage = () => {
    const workTimeReportProps = useWorkTimeReport();
    return <WorkTimeReportComponent {...workTimeReportProps} />
}

export default WorkTimeReportPage;